module.exports = __webpack_public_path__ + "img/code.26157d38.png";